// extracted by mini-css-extract-plugin
export default {"f":"_8ae9518bc4","main":"ad7060986e","btn":"_98e27fc724","w":"_1eb8e432d8","h":"a48746399b","lh25":"_5b3adbac27","wb":"b3d2ee7bed","b":"_674b198347","bx":"_81a148ae35"};